module.exports = __webpack_public_path__ + "static/media/Trading_Up_Tablet_Banner_STAKE@2x.2f4a0d9d.jpg";